import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";

import Breadcrumbs from "../../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import BackBtn from "../../../../components/Common/backBtn";
import InputRadioField from "../../../../components/Common/inputRadioField";
import InputTextField from "../../../../components/Common/inputTextField";
import SucessModal from "../../../../components/Modal/SucessModal";

const DoctorMedicalCouncilForm = ({ edit = false, view = false }) => {
  const { id } = useParams();

  const {
    register,
    setValue,
    watch,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const [success, setSuccess] = useState(false);

  const getMenuData = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}doctors-medical-council/get/${id}`)
      .then((response) => {
        setValue("active", response.data.active);
        setValue("medical_council", response.data.medical_council);
      })
      .catch((err) => {
        console.error(err);
        alert("Some error");
      });
  };

  useEffect(() => {
    (edit || view) && getMenuData();
  }, [edit]);

  const onSubmit = (fields) => {
    if (edit) {
      axios
        .patch(
          `${process.env.REACT_APP_API_URL}doctors-medical-council/update/${id}`,
          fields,
        )
        .then((response) => {
          if (response.data?._id) {
            setSuccess(true);
          } else {
            alert("Fail");
            console.log("failed...");
          }
        });
    } else {
      axios
        .post(
          `${process.env.REACT_APP_API_URL}doctors-medical-council/create`,
          fields,
        )
        .then((response) => {
          if (response.data?._id) {
            setSuccess(true);
          } else {
            alert("Fail");
            console.log("failed...");
          }
        });
    }
  };

  const breadcrumbsList = useMemo(
    () => [
      {
        text: "Doctor",
        link: "/add-new-doctors",
      },
      {
        text: "Common Heads",
        link: "/doctors-medical-council",
      },
      {
        text: "Medical Council",
        link: "/doctors-medical-council",
      },
      {
        text: edit
          ? "Edit Medical Council"
          : view
            ? "View Medical Council"
            : "Add New Medical Council",
        link: "",
      },
    ],
    [],
  );

  return (
    <>
      <Breadcrumbs
        className="w-100 healthsyMasterBreadCrumbs"
        breadcrumbsList={breadcrumbsList}
      />
      <BackBtn navigatePath="/doctors-medical-council" />
      <div className="healtharticle mt-5">
        {/* <div className="pt-3 ms-3">
                    <Breadcrumbs
                        breadcrumbText="Doctor"
                        breadcrumbLink="/add-new-doctors"
                        nestedText="Common Heads"
                        nestedLink=""
                        nestedText2="Medical Council"
                        nestedLink2=""
                        nestedText3={edit ? "Edit Medical Council" : "Add New Medical Council"}
                        nestedLink3=""
                    />
                </div> */}
        <form onSubmit={handleSubmit(onSubmit)} className="carr-dep-form">
          <div className="row car-dep-form">
            <div className="col-5">
              <InputTextField
                register={register}
                errors={errors}
                labelName="Medical Council"
                errorText="Please enter the Medical Council."
                name="medical_council"
                placeholder="Type here..."
                view={view}
              />
            </div>
            <div className="col-3">
              <InputRadioField
                register={register}
                errors={errors}
                setValue={setValue}
                watch={watch}
                disabled={view}
              />
            </div>
          </div>

          {!view && (
            <div className="car-dep-form-button">
              <button type="submit" style={{ marginTop: "5%", border: "none" }}>
                SUBMIT
              </button>
            </div>
          )}
        </form>
      </div>
      {success && (
        <SucessModal
          page={"/doctors-medical-council"}
          name="new medical council"
          post={edit ? "updated" : "added"}
        />
      )}
    </>
  );
};

export default DoctorMedicalCouncilForm;
